const Heart = ({ width = 36, height = 36, color = 'currentColor', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 36 36"
      fill="none"
      color={color}
      {...props}
    >
      <path
        d="M24.3333 5.25C23.1043 5.25 21.8922 5.53803 20.7929 6.09128C19.6936 6.64453 18.7374 7.4478 18 8.43748C17.0031 7.09949 15.6132 6.11115 14.0272 5.61247C12.4412 5.11379 10.7395 5.13004 9.1632 5.65893C7.58689 6.18782 6.21587 7.20252 5.24433 8.55932C4.2728 9.91612 3.75 11.5462 3.75 13.2187C3.75 22.7679 16.9313 30.2983 17.4854 30.617C17.6424 30.7059 17.8199 30.7517 18 30.7499C18.1803 30.753 18.358 30.7071 18.5146 30.617C20.942 29.1886 23.2187 27.5155 25.3097 25.6233C29.9146 21.453 32.25 17.2827 32.25 13.2187C32.25 11.1053 31.4159 9.0784 29.9313 7.58398C28.4466 6.08956 26.433 5.25 24.3333 5.25Z"
        fill={color}
      />
    </svg>
  )
}

export default Heart
